import { useIntl } from 'react-intl';
import { Text } from 'UILibrary';
import { Document432Icon } from './Document432Icon';
import { definedTranslation } from '../../../../i18n';

type UnsuportedFileViewProps = {
  fileName: string;
  fileType: string;
};

export function UnsuportedFileView({
  fileName,
  fileType,
}: UnsuportedFileViewProps) {
  const t = useIntl();
  const file = buildFileName(fileName, fileType);

  return (
    <div className="relative text-[#E4E4E4]">
      <Document432Icon />
      <Text
        variant="H3"
        style={textStyle}
        className="absolute top-1/2 left-1/2 min-w-[80%] text-[16px] leading-6 font-normal text-center text-[#86868B]"
      >
        {t.formatMessage(definedTranslation.previewFiles.noPreviewAvailable, {
          fileName: file,
          b: (chunks: React.ReactNode) => <b>{chunks}</b>,
        })}
      </Text>
    </div>
  );
}

/////

const textStyle = {
  transform: 'translate(-50%, -50%)',
};

function buildFileName(fileName: string, fileType: string): string {
  if (!fileName || !fileType) {
    return 'unknown_file';
  }

  if (fileName.endsWith(`.${fileType}`)) {
    return fileName;
  }

  if (!fileType) {
    return fileName;
  }

  return `${fileName}.${fileType}`;
}
